<template>
    <f7-page
        name="Machine L"
        class="onboardingBg"
    >
        <f7-navbar
            large
            no-hairline
            large-transparent
            inner-class="onboardingBg"
            title-large="Machine Learn"
        >
            <f7-nav-left>
                <f7-link
                    icon="ion-ios-arrow-left"
                    back
                />
            </f7-nav-left>
            <f7-nav-title>Machine Learn</f7-nav-title>
            <!-- <f7-nav-right>
                <f7-link @click="save()">Save</f7-link>
            </f7-nav-right> -->
        </f7-navbar>
        <f7-list media-list>
            <f7-list-item
                v-for="item in items"
                :key="'mm'+item.id"
                :title="item.name"
                :text="checkStatus(item)"
            />
        </f7-list>
    </f7-page>
</template>

<script>
import utils from '../../js/utils';

export default {
    store: ['api', 'text', 'user', 'coursesIndex', 'myTraits'],
    data () {
        return {
            items: [],
        };
    },
    computed: {},
    created: function () {

    },
    mounted: function () {
        this.getList();
    },
    methods: {
        checkStatus: function (item) {
            let text = 'Traits fit: '
            text += utils.checkTraits(this.myTraits, item) ? 'true' : 'false';
            text += ' | Completed: ' + (item.completed ? 'true' : 'false');
            text += ' | Type: ' + item.type;
            let eligible = 0;
            let completed = 0;
            if (item.units) {
                for (let i = 0; i < item.units.length; i++) {
                    const u = item.units[i];
                    if (utils.checkTraits(this.myTraits, u)) eligible++;
                    if (u.completed) completed++;
                }
            }
            text += ' | Units (completed/eligible/all): ' + completed + '/' + eligible + '/' + item.units.length;
            return text;
        },
        getList: function () {
            this.$http.get(`${this.api}/mlfeed`).then(
                (response) => {
                    this.items = [];
                    for (let i = 0; i < response.body.data.itemList.length; i++) {
                        const element = response.body.data.itemList[i];
                        if (this.coursesIndex[parseFloat(element.itemId)])
                            this.items.push(this.coursesIndex[parseFloat(element.itemId)])
                    }
                },
                e => {
                    console.error(e);
                }
            );
        }
    }
};
</script>

<style lang="less" scoped>
@import '../../css/colors.less';
.center {
    text-align: center;
}
.version {
    text-transform: uppercase;
    font-family: AndesMedium;
    letter-spacing: 1px;
    color: #ccc;
    line-height: 20px;
    text-transform: uppercase;
}
</style>
